<div class="grid">
  <div class="col-12 card">
    <p-panel header="Filters" [toggleable]="true" [collapsed]="false">
      <tj-admin-search
        [filter]="searchFilter"
        [page]="page"
      ></tj-admin-search>
    </p-panel>

    <p-toolbar styleClass="my-4" *tjHasRole="'ADMIN_EDIT'">
      <ng-template pTemplate="left">
      </ng-template>
      <ng-template pTemplate="right">
        <button
          pButton
          pRipple
          label="Create New Admin"
          icon="pi pi-plus"
          class="p-button-success"
          (click)="onCreateNewAdmin()"
        ></button>
      </ng-template>
    </p-toolbar>

    <tj-admin-list
      (editAdmin)="onEditAdmin($event)"
      (deleteAdmin)="onDeleteAdmin($event)"
      (onSort)="sort($event)"
      [admins]="this.admins()"
    ></tj-admin-list>
    <p-paginator [rows]="pageQuery.size" [totalRecords]="page?.totalElements"
                 [rowsPerPageOptions]="env.extendedRowsPerPage"
                 (onPageChange)="onGoToPage($event)"
                 [first]="pageQuery.number * pageQuery.size"></p-paginator>
  </div>
</div>

<!-- User Edit Dialog -->
<p-dialog
  [(visible)]="showEditDialog"
  [header]="editingAdmin ? 'Edit Admin' : 'Create Admin'"
  [modal]="true"
  [style]="{ width: '30rem' }"
  [draggable]="false"
  [resizable]="false"
>
  @if (showEditDialog) {
    <tj-admin-edit-form
      [isCreateMode]="!editingAdmin"
      [admin]="editingAdmin"
      (save)="onSaveUser($event)"
      (cancel)="closeEditDialog()"
    ></tj-admin-edit-form>
  }
</p-dialog>

<p-confirmDialog></p-confirmDialog>
